var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reservations-chart"},[_c('div',{staticClass:"title"},[_vm._v(" Statistika korištenja BeysTravel ")]),_c('canvas',{ref:"reservationsChart",attrs:{"id":"reservationChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }